export const MODALIDADE = {
  'BOOKSTER': 'MODALIDADE_BOOKSTER',
  'CURADORIA': 'MODALIDADE_CURADORIA',
  'INEDITOS': 'MODALIDADE_INEDITOS'
}

export const AVISO_PROCESSAMENTO = 'Seu cartão já está sendo processado, isto pode levar um minuto.'

export const AGUARDE_PROCESSAMENTO = 'Aguarde o processamento'

export const FECHAR = 'Fechar'

export const URLS_VIDEO = {
  'Curadoria': 'https://www.youtube.com/watch?v=EigjzhkYMiI',
  'Inéditos': 'https://www.youtube.com/watch?v=vetLjgp0y4U',
}

export const DESCRICAO_VIDEO = {
  'Curadoria': {
    'SUBTITULO': 'Espie o que vem por aí (contém spoilers):',
    'TITULO': 'Em novembro, vamos celebrar e homenagear a América Latina em um mês temático!',
  },
  'Inéditos': {
    'SUBTITULO': 'Espie o que vem por aí (contém spoilers):',
    'TITULO': 'Em novembro, vamos celebrar e homenagear a América Latina em um mês temático!',
  }
}

export const URL_PORTAL_CONEXAO = 'https://clube.taglivros.com/conexao-tag'
